import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { LandingService } from '../../../providers/landing.service';
import { Sort, MatExpansionPanel, MatTableDataSource, PageEvent, MatSort } from '@angular/material';
import { VolverService } from '../../../providers/volver.service';
import { Subscription } from 'rxjs';
import { ComunicacionService } from '../../../providers/comunicacion.service';
import { CotizacionService } from '../../../providers/cotizacion.service';

@Component({
  selector: 'app-listado-campana-venta',
  templateUrl: './listado-campana-venta.component.html',
  styleUrls: ['./listado-campana-venta.component.scss']
})
export class ListadoCamapanVentaComponent implements OnInit {
  readonly titulo = '_landing_';
  columnas = [
    'id',
    'nombre',
    'fecha_desde',
    'fecha_hasta',
    'activa',
    'acciones'
  ];
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  filtros: any = {
    generico: ''
  };
  cargando: boolean;
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  LandingDataSource = new MatTableDataSource();
  getClientesSuscripcion: Subscription;
  clientesCount: number = 0;
  tieneFiltrosOrdenPaginado = false;
  panelConFiltroActivo = false;
  total: number;
  max_progreso: number;
  estados: any = [];
  @ViewChild(MatSort) matSort: MatSort;
  @Output() onHoraInput = new EventEmitter();
  @Input() filtrosExternos: any = {}; // filtros que se aplican según el lugar donde se muestran las incidencias
  @ViewChild('filtrosPanel') set filtrosPanel(v: MatExpansionPanel) {
    if (typeof v != 'undefined') {
      setTimeout(() => {
        this.checkPageState();
        if (this.panelConFiltroActivo) {
          v.open();
        }
      }, 25);
    }
  };
  constructor
    (
      private _landingSv: LandingService,
      private _cmSv: ComunicacionService,
      private volverSv: VolverService,
  ) { }
  @Input('filtrado') filtrado: boolean = true;

  ngOnInit() {
    this.reiniciarPageState();
  }


  _limpiarPageState() {
    // filtros
    localStorage.setItem('ver_campana_venta_filtros', null);
    // paginado
    localStorage.setItem('ver_campana_venta_paginado', null);
    // sort
    localStorage.setItem('ver_campana_venta_sort', null);
  }


  recordarPageState() {
    // filtros
    localStorage.setItem('ver_campana_venta_filtros', JSON.stringify(this.filtros));
    // paginado
    localStorage.setItem('ver_campana_venta_paginado', JSON.stringify(this.page));
    // sort
    localStorage.setItem('ver_campana_venta_sort', JSON.stringify(this.sort));
  }

  checkPageState(): boolean {
    this.tieneFiltrosOrdenPaginado = false;
    // checkear si hay almenos un filtro aplicado
    this.panelConFiltroActivo = false;
    for (let propiedad in this.filtros) {
      if (this.filtros[propiedad]) {
        this.tieneFiltrosOrdenPaginado = true;
        this.panelConFiltroActivo = true;
        break;
      }
    }
    // checkear si hay paginado
    if (this.page.pageIndex != 0) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    // checkear si hay ordenamiento
    if (this.sort.active != '' && (this.sort.active != 'fecha_hasta' || this.sort.direction != 'desc')) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    return this.tieneFiltrosOrdenPaginado;
  }
  restaurarPageState() {
    // filtros
    let localFiltros = JSON.parse(localStorage.getItem('ver_campana_venta_filtros'));
    if (localFiltros != null) {
      this.filtros = localFiltros;
    } else {
      for (let propiedad in this.filtros) {
        this.filtros[propiedad] = '';
      }
    }
    // paginado
    let localPaginado = JSON.parse(localStorage.getItem('ver_campana_venta_filtros'));
    if (localPaginado != null) {
      this.page = localPaginado;
    } else {
      this.page.pageIndex = 0;
      this.page.pageSize = +localStorage.getItem('vercampana_venta_paginado_size') || 10;
      this.page.length = 0;
    }
    // sort
    let localSort = JSON.parse(localStorage.getItem('ver_campana_ventasort'));
    if (localSort != null) {
      // para el sort tenemos que hacerlo con un "set" porque arregla un bug de "matSort"
      this.setActiveSortProgrammatically(localSort.active, localSort.direction);
    } else {
      this.setActiveSortProgrammatically('fecha_hasta', 'desc');
    }
    this.actualizarTabla();
  }
  /**
 * Para arreglar un bug de angular usamos esta funcion para ordenar
 */
  setActiveSortProgrammatically(active, direction): void {
    let interval = setInterval(() => {
      if (this.matSort) {
        clearInterval(interval);
        if (this.sort.active != active || this.sort.direction != direction) {
          this.sort = <MatSort>{
            active: active,
            direction: direction
          };
          this.matSort.sort({
            id: active,
            start: direction,
            disableClear: true
          });
          // ugly hack!
          const activeSortHeader = this.matSort.sortables.get(active);
          if (activeSortHeader) {
            activeSortHeader['_setAnimationTransitionState']({
              fromState: direction,
              toState: 'active'
            });
          }
        }
      }
    }, 0);
  }

  sortData(sort: Sort) {
    this.sort = sort;
    this.actualizarTabla();
  }

  onPage(pageEvent: PageEvent) {
    localStorage.setItem('ver_campana_venta_paginado_size', pageEvent.pageSize.toString());
    this.page = pageEvent;
    this.actualizarTabla();
  }

  onFiltro() {
    this.page.pageIndex = 0;
  }
  reiniciarPageState() {
    this._limpiarPageState();
    this.restaurarPageState();
  }
  actualizarTabla(): void {
    this.cargando = true;
    this.recordarPageState();
    this.checkPageState();
    this._landingSv.getCampanias(
      {
        page: this.page.pageIndex,
        pageSize: this.page.pageSize
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      Object.assign(this.filtros)
    )
      .subscribe(
        respuesta => {
          this.cargando = false;
          const data = this._cmSv.format(respuesta, false);
          // console.log(data);
          if (data != this._cmSv.SIN_DATA) {
            this.LandingDataSource.data = data.campanias.map(campanias => {
              return campanias
            });
            this.total = data.total;
          }
        },
        () => {
          this.cargando = false// ocultar progress bar si se estaba mostrando
        },
        () => {
          this.cargando = false; // ocultar progress bar si se estaba mostrando
        }
      );
  }

}
